import * as React from "react";
import { Redirect } from "wouter";

/**
 * Handles older Stages Tracking Widget urls that used to point to /proxy-path?orderId=12345. If the url does not contain an order id, the user is redirected to /proxy-path/search.
 */
export function OldRouteRedirector(): JSX.Element {
    const orderId = React.useMemo(() => {
        const query = new URLSearchParams(window.location.search);
        const orderId = query.get("orderId");

        return orderId;
    }, [window.location.search]);
    const redirectUrl = orderId ? `/order/${orderId}` : `/search`;

    return (
        <Redirect to={redirectUrl} replace={true} />
    );
}
